import React, { useState, useEffect, useCallback } from 'react';

const ContactSection = () => {
  const [showTelegramDialog, setShowTelegramDialog] = useState(false);
  const [showEmailDialog, setShowEmailDialog] = useState(false);
  const [copied, setCopied] = useState(false);

  const telegramId = "@merlinboii";
  const telegramLink = "https://t.me/merlinboii";
  const emailAddress = "merlinboii.tech@gmail.com";

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(err => console.error('Could not copy: ', err));
  };

  // Handle click on overlay to close dialog
  const handleOverlayClick = (e, setDialogState) => {
    // Only close if clicking the overlay itself, not its children
    if (e.target === e.currentTarget) {
      setDialogState(false);
    }
  };

  const closeAllDialogs = useCallback(() => {
    setShowTelegramDialog(false);
    setShowEmailDialog(false);
  }, []);

  // Close dialogs on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && (showTelegramDialog || showEmailDialog)) {
        closeAllDialogs();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [showTelegramDialog, showEmailDialog, closeAllDialogs]);

  return (
    <section id="contact">
      <div className="container">
        <h2 className="topic">Contact</h2>
        <div className="contact-container-simple">
          <div className="contact-info-centered">
            <h3 style={{fontFamily: 'Sanfrisco'}}>Get in Touch</h3>
            
            <div className="contact-buttons">
              <button 
                onClick={() => setShowTelegramDialog(true)}
                className="telegram-button pixel-border-1"
              >
                Telegram
              </button>
              
              <button 
                onClick={() => setShowEmailDialog(true)}
                className="email-button pixel-border-1"
              >
                Email
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* Telegram Dialog */}
      {showTelegramDialog && (
        <div 
          className="mac-dialog-overlay"
          onClick={(e) => handleOverlayClick(e, setShowTelegramDialog)}
        >
          <div className="mac-dialog pixel-border">
            <div className="mac-dialog-title-bar">
              <div className="mac-dialog-title">Telegram Contact</div>
              <button 
                className="mac-dialog-close" 
                onClick={() => setShowTelegramDialog(false)}
              >
                ×
              </button>
            </div>
            <div className="mac-dialog-content">
              <p>Telegram: <span className="contact-value">{telegramId}</span></p>
              <div className="mac-dialog-buttons">
                <button 
                  className="mac-button pixel-border-1"
                  onClick={() => copyToClipboard(telegramId)}
                >
                  Copy
                </button>
                <button 
                  className="mac-button primary pixel-border-1"
                  style={{color: '#fff'}}
                  onClick={() => window.open(telegramLink, '_blank')}
                >
                  Open Telegram
                </button>
              </div>
              {copied && <div className="copied-notification">Copied!</div>}
            </div>
          </div>
        </div>
      )}
      
      {/* Email Dialog */}
      {showEmailDialog && (
        <div 
          className="mac-dialog-overlay"
          onClick={(e) => handleOverlayClick(e, setShowEmailDialog)}
        >
          <div className="mac-dialog pixel-border">
            <div className="mac-dialog-title-bar">
              <div className="mac-dialog-title">Email Contact</div>
              <button 
                className="mac-dialog-close" 
                onClick={() => setShowEmailDialog(false)}
              >
                ×
              </button>
            </div>
            <div className="mac-dialog-content">
              <p>Email: <span className="contact-value">{emailAddress}</span></p>
              <div className="mac-dialog-buttons">
                <button 
                  className="mac-button pixel-border-1"
                  onClick={() => copyToClipboard(emailAddress)}
                >
                  Copy
                </button>
              </div>
              {copied && <div className="copied-notification">Copied!</div>}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ContactSection;
